export default __webpack_public_path__ + "media/images/images/carousel/10-f98769afb3084f7bb52d5067323387eb.jpg";